export const APP_TEXT = {
  booting: '불러오는 중',
  unreachableTitle: '서버에 연결할 수 없습니다',
  unreachableDescription: '로그인 상태는 그대로입니다. 네트워크를 확인한 뒤 다시 시도해 주세요.',
  maintenanceTitle: '서비스 점검 중입니다',
  maintenanceDescription: '점검이 끝난 뒤 다시 이용해 주세요.',
  retry: '다시 시도',
  forbiddenTitle: '권한이 없습니다',
  forbiddenDescription: '이 화면을 볼 수 있는 권한이 없습니다.',
  goHome: '처음으로',
  loginRequiredTitle: '로그인이 필요합니다',
  loginRequiredDescription: '로그인 화면이 아직 준비되지 않았습니다.',
} as const;
